import React, { Dispatch, SetStateAction, useEffect, useRef } from 'react'
import './styles.scss'
import { config } from './config'

interface Props {
  selected: boolean
  content: CarouselElement
  handleChange: (parameter: string, value: string | number | number[]) => void
  parameter: covidDoseParameter | 'all'
  ismobile: boolean
  id: number
  type: 'Szenario' | 'Parameter'
  autoScroll: boolean
}

export const CarouselElement = ({
  selected,
  content,
  handleChange,
  parameter,
  ismobile,
  id,
  type,
  autoScroll = true
}: Props) => {
  const { name, value, desc } = content
  const elementRef = useRef<HTMLButtonElement | undefined>()
  return (
    <button
      ref={elementRef}
      className={
        'CarouselElement' +
        (selected ? ' selected' : '') +
        (type === 'Szenario' ? ' szenario' : '')
      }
      onClick={!ismobile ? () => handleChange(parameter, value) : undefined}
      onTouchStart={autoScroll ? undefined : () => handleChange(parameter, value)}
      disabled={selected}
      tabIndex={selected ? undefined : 1}
    >
      <div className='infowrapper'>
        <div className='name'> {name}</div>
        <div className='desc'> {desc || <>&nbsp;</>}</div>
      </div>
      <img src={require(`images/icons/icons_${parameter}_${id}.png`)} />
    </button>
  )
}
export const CarouselElementInvisible = ({
  type
}: {
  type: 'Szenario' | 'Parameter'
}) => (
  <div
    className={
      'CarouselElementInvisible' + (type === 'Szenario' ? ' szenario' : '')
    }
  >
    &nbsp;
  </div>
)
